import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useT } from "@/lib/i18n";

const INSTAGRAM_URL = "https://www.instagram.com/kaily_gan/";
const EMAIL = "kailygan.my@gmail.com";
const WHATSAPP_NUMBER = "60183628663";
const WHATSAPP_DISPLAY = "+60 18-362 8663";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;

export default function SiteFooter() {
    const { t } = useT();
    const addr = t("footer.studio_addr") || "";
    const [addrLine1, addrLine2] = addr.split("\n");

    return (
        <footer className="bg-cafe-espresso text-cafe-cream overflow-x-clip">
            <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 lg:gap-16">
                    <div className="md:col-span-6 min-w-0">
                        <Link to="/" className="inline-block font-serif text-6xl md:text-8xl lg:text-9xl tracking-tight leading-none">
                            kaily<span className="text-cafe-terracotta">.</span>
                        </Link>
                        <p className="mt-6 max-w-md text-cafe-cream/70 leading-relaxed">
                            {t("footer.tagline")}
                        </p>
                    </div>

                    <div className="md:col-span-2 min-w-0">
                        <div className="text-xs uppercase tracking-[0.25em] text-cafe-terracotta mb-4">{t("footer.studio")}</div>
                        <p className="text-cafe-cream/80 leading-relaxed text-sm">
                            {addrLine1}<br />
                            {addrLine2}
                        </p>
                    </div>

                    <div className="md:col-span-2 min-w-0">
                        <div className="text-xs uppercase tracking-[0.25em] text-cafe-terracotta mb-4">{t("footer.contact")}</div>
                        <a href={`mailto:${EMAIL}`} className="block text-cafe-cream/80 hover:text-cafe-terracotta transition-colors text-sm break-words">{EMAIL}</a>
                        <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="block mt-1 text-cafe-cream/80 hover:text-cafe-terracotta transition-colors text-sm">{WHATSAPP_DISPLAY}</a>
                    </div>

                    <div className="md:col-span-2 min-w-0">
                        <div className="text-xs uppercase tracking-[0.25em] text-cafe-terracotta mb-4">{t("footer.follow")}</div>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 text-cafe-cream/90 hover:text-cafe-terracotta transition-colors"
                            data-testid="footer-instagram"
                        >
                            <Instagram className="h-4 w-4" strokeWidth={1.5} />
                            @kaily_gan
                        </a>
                    </div>
                </div>

                <div className="mt-16 pt-6 border-t border-cafe-cream/15 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-cafe-cream/50">
                    <div>© {new Date().getFullYear()} Kaily F&amp;B Visual Studio · slowcafe.my</div>
                    <div className="flex items-center gap-3">
                        <span>{t("footer.made_slow")}</span>
                        <Link to="/studio" className="hover:text-cafe-terracotta transition-colors" data-testid="footer-studio-link">
                            {t("footer.studio_link")}
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
